import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import themeColors from '../../assets/styles/themeColors';
import { variables } from '../../assets/styles/variables';

const ParagraphStyle = styled.p`
  color: ${({ color }) => color};
  font-size: ${({ variant }) => () => variables.typography.p[variant].fontSize};
  line-height: ${({ variant }) => () =>
    variables.typography.p[variant].lineHeight};
  margin-bottom: ${({ mb }) => (mb ? `${mb}px` : 0)};
  margin-top: ${({ mt }) => (mt ? `${mt}px` : 0)};
  margin-left: ${({ ml }) => (ml ? `${ml}px` : 0)};
  font-weight: ${({ fontWeight }) => fontWeight || 400};
  text-decoration: ${({ textDecoration }) => textDecoration || 'initial'};
  ${({ verticalAlign }) =>
    verticalAlign &&
    `
  vertical-align: baseline;
`}

  @media only screen and (max-width: 500px) {
    font-size: ${({ emailVariant }) => emailVariant && `0.9rem`};
    line-height: ${({ emailVariant }) => emailVariant && `1.6`};
    text-align: ${({ emailVariant }) => emailVariant && `end`};
  }

  @media only screen and (max-width: 420px) {
    font-size: ${({ emailVariant }) => emailVariant && `1.1rem`};
  }
`;

const Paragraph = ({
  color = themeColors.colorTextSecondary,
  variant = 'regular',
  emailVariant,
  mb,
  mt,
  ml,
  children,
  fontWeight,
  textDecoration,
  verticalAlign,
}) => (
  <ParagraphStyle
    fontWeight={fontWeight}
    mb={mb}
    mt={mt}
    ml={ml}
    color={color}
    variant={variant}
    textDecoration={textDecoration}
    emailVariant={emailVariant}
    verticalAlign={verticalAlign}
  >
    {children}
  </ParagraphStyle>
);

Paragraph.propTypes = {
  color: PropTypes.string,
  variant: PropTypes.string,
  children: PropTypes.node,
  mb: PropTypes.number,
  mt: PropTypes.number,
  ml: PropTypes.number,
  fontWeight: PropTypes.number,
  textDecoration: PropTypes.string,
  emailVariant: PropTypes.bool,
  verticalAlign: PropTypes.bool,
};

export default Paragraph;
